<template>
  <div>
    <span>{{time | change}}</span>
  </div>
</template>

<script>
  let flag = false
  export default {
    data () {
      return {
        time : '検証コードを取得する',
      }
    },
    props : {
      start : {
        type : Boolean
      }
    },
    watch : {
      start (value,oldvalue) {
        if(value == true){
          this.countDown()
        }
      }
    },
    methods: {
      countDown () {
        this.time = 60;
        let time = setInterval(()=>{
          this.time --
          if(this.time == 0){
            this.$emit('countDown')
            this.time = '再送してください'
            flag = true
            clearInterval(time)
          }
        },1000)
      }
    },
    filters : {
      change (value) {
//        console.log(value);
        if(!value) return ""
        if(!isNaN(value)){
          if(flag == true){
            return `${value}S`
          }
          return value+'S'
        }else{
          return value
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/common/countInfo.vue